/**
 * Menu Filtering Utilities
 * Handles filtering logic for menu items
 */

/**
 * Filter menu items based on search, category, subcategory, offers, and dietary preferences
 * @param {Array} items - Array of menu items
 * @param {string} searchQuery - Search query string
 * @param {string} selectedCategory - Selected category ID
 * @param {string} selectedSubcategory - Selected subcategory ID
 * @param {boolean} showOffersOnly - Whether to show only offer items
 * @param {Array} offerItems - Array of offer items
 * @param {Object} dietaryFilters - Dietary filter preferences {isVegetarian, isVegan, isSpicy}
 * @returns {Array} - Filtered menu items
 */
export const filterMenuItems = (
    items,
    searchQuery,
    selectedCategory,
    selectedSubcategory,
    showOffersOnly,
    offerItems = [],
    dietaryFilters = {}
) => {
    if (!Array.isArray(items)) return [];

    let filtered = [...items];

    // Filter by offers
    if (showOffersOnly) {
        const offerItemIds = offerItems.map((item) => item.id);
        filtered = filtered.filter((item) => offerItemIds.includes(item.id));
    }

    // Filter by category
    if (selectedCategory && selectedCategory !== "all") {
        filtered = filtered.filter((item) => item.categoryId === selectedCategory);
    }

    // Filter by subcategory
    if (selectedSubcategory && selectedSubcategory !== "all") {
        filtered = filtered.filter(
            (item) => item.subcategoryId === selectedSubcategory
        );
    }

    // Filter by dietary preferences
    if (dietaryFilters.isVegetarian) {
        filtered = filtered.filter((item) => item.isVegetarian);
    }
    if (dietaryFilters.isVegan) {
        filtered = filtered.filter((item) => item.isVegan);
    }
    if (dietaryFilters.isSpicy) {
        filtered = filtered.filter((item) => item.isSpicy);
    }

    // Filter by search query
    if (searchQuery && searchQuery.trim() !== "") {
        const query = searchQuery.toLowerCase().trim();
        filtered = filtered.filter(
            (item) =>
                item.name.toLowerCase().includes(query) ||
                item.description?.toLowerCase().includes(query)
        );
    }

    return filtered;
};
